/**
 * Адрес, на который возвращаем пользователя после входа.
 *
 * Путь раньше кодировался btoa напрямую, а btoa умеет только Latin1 и бросает
 * InvalidCharacterError на любой не-латинице. На адресе вида
 * /persons?search=Иванов обработчик 401 падал на этой строке - до
 * router.push({ name: "login" }), - и истёкшая сессия выглядела как полное
 * отсутствие реакции: пользователя не уводило на авторизацию. То же самое
 * ломало redirect в middleware auth. encodeURIComponent приводит путь к ASCII,
 * поэтому btoa больше не падает.
 *
 * Сохранение адреса - вспомогательная вещь и не должна мешать уходу на логин,
 * поэтому ни одна функция здесь не бросает.
 */
const KEY = btoa("redirect");

/**
 * Текущий адрес браузера, относительно базы роутера.
 *
 * Берём window.location, а не router.currentRoute: обработчик 401 срабатывает
 * и во время старта приложения (initUserData дёргает authGetUser, если в
 * localStorage есть токен), а роутер к тому моменту ещё не разрешил первый
 * переход - currentRoute.value.fullPath отдаёт "/", и страница, с которой
 * пользователь пришёл, терялась.
 *
 * BASE_URL отрезаем: роутер работает с путями относительно базы, а
 * location.pathname содержит её целиком - иначе префикс удвоился бы.
 */
export function CurrentBrowserPath() {
  try {
    const base = (import.meta.env.BASE_URL || "/").replace(/\/+$/, "");
    const { pathname, search, hash } = window.location;
    const path = base && pathname.startsWith(base) ? pathname.slice(base.length) || "/" : pathname;

    return `${path.startsWith("/") ? path : `/${path}`}${search}${hash}`;
  } catch (e) {
    console.error("[auth] не удалось определить текущий адрес", e);

    return "/";
  }
}

export function SetRedirectPath(path) {
  if (!path) return;

  try {
    localStorage.setItem(KEY, btoa(encodeURIComponent(path)));
  } catch (e) {
    console.error("[auth] не удалось сохранить адрес возврата", e);
  }
}

/**
 * Возвращает сохранённый путь или "/". Принимаем только относительный адрес:
 * в localStorage может лежать что угодно, а значение уходит в router.push.
 */
export function GetRedirectPath() {
  try {
    const stored = localStorage.getItem(KEY);
    if (!stored) return "/";

    const path = decodeURIComponent(atob(stored));

    return path.startsWith("/") && !path.startsWith("//") ? path : "/";
  } catch (e) {
    console.error("[auth] не удалось прочитать адрес возврата", e);

    return "/";
  }
}

export function ClearRedirectPath() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    console.error("[auth] не удалось очистить адрес возврата", e);
  }
}
